var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 21.875L1.25168e-06 15L6.875 8.125L8.6375 9.8875L4.7875 13.75L11.875 13.75C15 13.75 17.5 11.25 17.5 8.125L17.5 -1.09278e-07L20 0L20 8.125C20 10.2799 19.144 12.3465 17.6202 13.8702C16.0965 15.394 14.0299 16.25 11.875 16.25L4.7875 16.25L8.65 20.1125L6.875 21.875V21.875Z",
    fill: "#5AB2AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoff);
export default __webpack_public_path__ + "static/media/logoff.2505a7e9e59793c209b18acd07fc7fd0.svg";
export { ForwardRef as ReactComponent };